export default __webpack_public_path__ + "static/media/events-list.7c116428.png";